import DefaultMoment from "moment";

const fixDate = value => {
  if (value.length === 2 || value.length === 5 || value.length === 10) {
    // Split dd/mm/yyyy to dd
    if (value.length === 2) {
      const fixedDate = value.split("/");
      return DefaultMoment(`${fixedDate}`, "DD").format("DD");
    } else if (value.length === 5) {
      // Split dd/mm/yyyy to mm/dd
      const fixedDate = value.split("/");
      return DefaultMoment(`${fixedDate[1]}/${fixedDate[0]}`, "MM/DD").format(
        "MM/DD"
      );
    } else if (value.length === 10) {
      // Split dd/mm/yyyy to mm/dd/yyyy
      const fixedDate = value.split("/");
      return DefaultMoment(
        new Date(`${fixedDate[1]}/${fixedDate[0]}/${fixedDate[2]}`)
      ).format("YYYY/MM/DD");
    }
  }
};
export default fixDate;
